import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
SwiperCore.use([Autoplay, Pagination, Navigation]);

@Component({
  selector: 'app-onboarding-explore',
  templateUrl: './onboarding-explore.page.html',
  styleUrls: ['./onboarding-explore.page.scss'],
})
export class OnboardingExplorePage implements OnInit {

  @ViewChild('swiper') swiper: SwiperComponent;

  buttonsChanged:boolean = false;

  constructor(
    public router: Router,
    private changeDetection : ChangeDetectorRef,
  ) { }

  ngOnInit() {
  }

  moveToNext() {
    this.swiper.swiperRef.slideNext();
  }

  moveToPrev() {
    this.swiper.swiperRef.slidePrev();
  }

  slideChanged(evt) {
    if (this.swiper.swiperRef.activeIndex < 4) {
      this.buttonsChanged = false;
    } else {
      this.buttonsChanged = true;
    }
    this.changeDetection.detectChanges();

  }

  navigateToHome() {
    localStorage.setItem('isOnboardingVisible', 'false');
    this.router.navigate(['/'], { queryParams: {showAgePopover: true} });
  }

}
